module.exports = __webpack_public_path__ + "img/pride-day-light-small.1c747cd2.svg";